import { loginConstants } from '../_constants/login.constants';
export function success(data) { return { type: loginConstants.LOGIN_SUCCESS, data } }
export function failure(error) { return { type: loginConstants.LOGIN_FAILURE, error } }